<template>
  <div class="display mt32">
    <div class="tabs mb16">
      <div
        class="tab"
        v-for="(tab, i) of tabs"
        :key="i"
        :class="{ 'active': active == i }"
        @click="active = i"
      >
        {{ tab.title }}
      </div>
    </div>

    <div class="plane">
      <div class="side"><span>常<br/>规</span></div>

      <template v-for="(tab, index) of tabs">
        <div class="list" v-show="active == index" :key="index">
          <el-checkbox-group v-model="tab.checked">
            <el-checkbox v-for="(item, i) of tab.list" :key="i" :label="item">{{ item }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </div>

    <zt-button width="140px" type="primary" class="mt24" @click="onSaveClick" :loading="loading">保存</zt-button>
  </div>
</template>

<script>
import { taoke_cms_modules_open_set } from '@/api/cmsWebSite'
export default {
  name: 'display',
  props: {
    info: Object,
  },
  data: () => ({
    active: 0,
    tabs: [
      {
        title: '会员身份',
        list: ['邀请码', '我的订单', '收益和到账金额', '分销中心模块'],
        checked: [],
        key: 'member_modules',
      },
      {
        title: '代理身份',
        list: ['邀请码', '我的订单', '收益和到账金额', '分销中心模块'],
        checked: [],
        key: 'agent_modules',
      },
      {
        title: '未登录',
        list: ['商品佣金', '详情页未登录提示', '分销中心模块', '收益和到账金额', '签到有奖'],
        checked: [],
        key: 'default_modules',
      },
    ],
    
    loading: false,
  }),
  watch: {
    'info':{
      immediate: true,
      deep: true,
      handler(val) {
        const datas = [
          val.cms_member_modules_open,
          val.cms_agent_modules_open,
          val.cms_default_modules_open,
        ]

        datas.forEach((data, i) => {
          if (!data) return

          const tab = this.tabs[i]
          tab.checked.splice(0)
          // ['-'] 是默认全选（新用户注册过后未修改过就会是这个值）
          if (data.length == 1 && data[0] === '-') {
            tab.checked.push(...tab.list)
          }
          else {
            tab.checked.push(...data)
          }
        })
        
      },
    },
  },
  methods: {
    onChangeTabClick(active) {
      this.active = active
    },

    async onSaveClick() {
      this.loading = true
      const params = {}
      this.tabs.forEach((tab) => {
        params[tab.key] = tab.checked.join(',')
      })
      const { data } = await taoke_cms_modules_open_set(params)
      if (data.error_code == 0) {
        this.$store.dispatch('GetCmsInfo')
        this.$message.success('保存成功')
      }
      else {
        this.$message.error(data.error_message)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  font-size: 0;
  background: #F0F2F5;
  border-radius: 4px;
  display: inline-flex;
  padding: 2px;

  .tab {
    display: inline-block;
    font-size: 14px;
    padding: 9px 15px;
    border-radius: 4px;
    transition: all .2s;
    cursor: pointer;
  }
  .active {
    background: #fff;
  }
}

.plane {
  display: flex;
  min-height: 160px;
  border: 1px solid $theme-border4;
  border-radius: 2px;

  .side {
    background: $theme-border4;
    display: flex;
    align-items: center;
    padding: 0 9px;
    font-size: 14px;
  }

  .list {
    padding: 24px 25px;
  }
}
</style>